import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const HeroSection = ({ image }) => (
  <section className="relative flex min-h-[76svh] items-end overflow-hidden md:min-h-[84svh]">
    <img
      src={image}
      alt="Cynos oversized streetwear lifestyle banner"
      className="absolute inset-0 h-full w-full object-cover"
      loading="eager"
      decoding="async"
      fetchPriority="high"
      sizes="100vw"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/35 to-black/95" />
    <div className="absolute inset-0 grain" />
    <div className="relative z-10 w-full px-4 pb-8 md:px-8 md:pb-10 lg:px-12">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
        <span className="font-mono text-[10px] uppercase tracking-[0.26em] text-cynos-red md:text-xs">Drop 01 / Live Now</span>
      </motion.div>
      <motion.h1
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.1 }}
        className="mt-3 font-anton text-[14vw] uppercase leading-[0.86] md:text-[10vw] lg:text-[7.5rem] xl:text-[8.75rem]"
      >
        Wear<br />
        <span className="text-cynos-red">Your</span><br />
        Attitude.
      </motion.h1>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6, delay: 0.5 }} className="mt-5 max-w-xl">
        <p className="text-sm leading-6 text-zinc-300 md:text-base">Premium 240 GSM cotton tees / COD / fast shipping across India.</p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <Link to="/shop" className="group inline-flex min-h-[52px] items-center justify-center gap-2 rounded-[8px] bg-white px-8 font-mono text-[11px] uppercase tracking-[0.18em] text-black transition-colors hover:bg-zinc-200 md:text-xs" data-testid="hero-shop-button">
            Shop Now <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>
          <Link to="/shop?sort=newest" className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-[8px] border border-white/30 px-8 font-mono text-[11px] uppercase tracking-[0.18em] text-white transition-colors hover:border-white md:text-xs" data-testid="hero-new-arrivals-button">
            New Arrivals
          </Link>
        </div>
      </motion.div>
    </div>
  </section>
);

export default HeroSection;
